import { render, staticRenderFns } from "./BranchClosingStatements.vue?vue&type=template&id=53c3ce2a&"
import script from "./BranchClosingStatements.vue?vue&type=script&lang=js&"
export * from "./BranchClosingStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports